export const CHANGE_NAV_COLOR = "CHANGE_NAV_COLOR";
export const CHANGE_setScrollToServicesSection =
  "CHANGE_setScrollToServicesSection";
export const CHANGE_setScrollToProductsSection =
  "CHANGE_setScrollToProductsSection";
